import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { ContractTemplateFieldType } from './contract-template-field-type.interface';

export class ContractTemplateFieldTypeService {
   async getContractTemplateFieldTypes() {
      const response = await http.get<PaginatedResponse<ContractTemplateFieldType>>(`/contract-template-field-types`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }
}
